import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import {
  et3ParseInteger,
  getOnlyDigitsFromString,
  isPositiveNumber
} from "et3-type-guards";
import i18n from "../../../../../constants/i18n";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../../../../constants/input-entries-constants";
import {
  ONE_O_ONE_C_AI_STATS_FILTER,
  ONE_O_ONE_C_AI_STATUS_FILTER,
  USER_SEARCH_BY_PLACEHOLDERS
} from "../../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Date from "../../../../../core/et3-input/et3-date";
import { getKhattabaAiStore } from "../../../../../stores/khattabat-stores/ai-stores/khattaba-ai-store";
import FilterSelect from "../../../matching/search-and-101m/form/FilterSelect";
import KhattabatFilterMultiSelect from "../KhattabatFilterMultiSelect";

const KhattabatAiFilter = withLiteObserverAndTheme(() => {
  const {
    userID,
    dateMinInput,
    dateMaxInput,
    statusFilter,
    statsFilter,
    setUserID,
    setStatusFilter,
    setStatsFilter,
    getKhattabaClients
  } = getKhattabaAiStore();

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="flex-start"
      flexWrap="wrap"
      useFlexGap
      sx={{ width: "100%" }}
    >
      <Stack spacing={1}>
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={dateMinInput}
          isEnabled={true}
        />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={dateMaxInput}
          isEnabled={true}
        />
      </Stack>
      <Stack spacing={2} sx={{ minWidth: 240, flex: 1 }}>
        <FilterSelect
          label={i18n.get("KHATTABA_QUIZ_STATUS")}
          options={ONE_O_ONE_C_AI_STATUS_FILTER}
          value={statusFilter.get()}
          onChange={setStatusFilter}
        />
        <KhattabatFilterMultiSelect
          label={i18n.get("KHATTABA_QUIZ_STATS")}
          options={ONE_O_ONE_C_AI_STATS_FILTER}
          value={statsFilter.get()}
          onChange={setStatsFilter}
        />
      </Stack>
      <TextField
        size="small"
        label={i18n.get("USER_ID")}
        value={isPositiveNumber(userID.get()) ? `${userID.get()}` : ""}
        placeholder={USER_SEARCH_BY_PLACEHOLDERS.userId}
        helperText={i18n.get("AI_FILTER_USER_ID_DOMINANCE")}
        onChange={({ target }) => {
          const parsedStringValue = getOnlyDigitsFromString(target.value);
          if (parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED) {
            setUserID(et3ParseInteger(parsedStringValue));
          }
        }}
        onKeyDown={async (event) => {
          if (event.key === "Enter" && isPositiveNumber(userID.get())) {
            await getKhattabaClients();
          }
        }}
        slotProps={{ htmlInput: { inputMode: "numeric" } }}
        sx={{ minWidth: 240, flex: 1 }}
      />
      <Button variant="contained" onClick={() => getKhattabaClients()}>
        {i18n.get("GET")}
      </Button>
    </Stack>
  );
});

export default KhattabatAiFilter;
